<template>
  <q-page padding>
    <div style="align-items: center" class="row col-12">
      <p class="text-h6 text-brand-1 text-weight-bold">
        Logs de Upload de Planilha
      </p>
    </div>
    <div class="row text-brand-5 text-weight-bold q-mt-md">
      <div class="q-ml-sm col-md-2">
        Linhas por Pagina:
        <q-input
          class="input-new-design"
          v-model="filtros.perPage"
          dense
          outlined
          type="number"
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Mapeamento:
        <q-select
          v-model="filtros.mapeamento"
          option-label="listaMapeamento"
          :options="listaMapeamento"
          dense
          class="input-new-design"
          outlined
          :rules="[(val) => !!val || 'Este campo é obrigatório']"
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Matrícula:
        <q-input
          type="number"
          v-model="filtros.matricula"
          min="0"
          class="input-new-design"
          dense
          outlined
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>

      <div class="q-ml-sm col-md-2">
        Usuário ID:
        <q-input
          class="input-new-design"
          v-model="filtros.usuario_id"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Usuário Nome:
        <q-input
          class="input-new-design"
          v-model="filtros.usuario_nome"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Perfil:
        <q-input
          class="input-new-design"
          v-model="filtros.role"
          :model-value="String(filtros.role || '')"
          @update:model-value="(val) => (filtros.role = String(val))"
          dense
          outlined
        />
      </div>

      <div class="q-ml-sm col-md-2">
        Data Inicial:
        <q-input
          v-model="filtros.data_inicial"
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.data_inicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="q-ml-sm col-md-2">
        Data Final:
        <q-input
          v-model="filtros.data_final"
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.data_final"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
    </div>

    <div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        class="tabela-tamanho-fixo q-mt-md"
        :rows-per-page-options="[0]"
        hide-pagination
        row-key="name"
        track-by="id"
      >
        <template v-slot:top-right>
          <!--<q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter"
            placeholder="Filtrar por nome"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>-->
        </template>
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todos os Logs: {{ logsQuantidade }}</span
          >
        </template>
        <template #body-cell-url="props">
          <q-td style="white-space: normal">
            <p style="max-width: 600px; overflow: hidden">
              <q-btn
                label="Baixar Planilha"
                outline
                no-caps
                flat
                icon="visibility"
                @click="baixarPlanilha(props.row.url)"
              />
            </p>
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="verLog">
      <q-card>
        <q-card-section> </q-card-section>

        <q-card-section class="q-pt-none">
          <vue-json-pretty :data="log" />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "acao",
    label: "Ação",
    field: "acao",
    align: "left",
  },
  {
    name: "unidadde",
    label: "Unidade",
    field: (row) => row.unidadeNome,
    align: "left",
  },
  {
    name: "matricula",
    label: "Matrícula",
    field: "matricula",
    align: "left",
  },
  {
    name: "mapeamento",
    label: "Nome da planilha",
    field: "mapeamento",
    align: "left",
  },
  {
    name: "usuarioNome",
    label: "Usuário",
    align: "left",
    field: "usuarioNome",
  },
  {
    name: "usuarioId",
    label: "ID Usuário",
    field: "usuarioId",
    align: "left",
  },
  {
    name: "url",
    label: "Planilha",
    field: "url",
    align: "left",
  },
  {
    name: "createdAt",
    label: "Data",
    field: (row) => date.formatDate(row.createdAt, "DD/MM/YYYY HH:mm:ss"),
    align: "left",
  },
  {
    name: "role",
    label: "Perfil",
    field: "role",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { watchDebounced } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";
import { format } from "date-fns";
import { date } from "quasar";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import { validarDataEmissao } from "../../../helpers/dateValidation";
export default {
  components: { VueJsonPretty },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const router = useRouter();
    const disable = ref(true);
    const filter = ref("");
    const verLog = ref(false);
    const log = ref(null);
    const logsQuantidade = ref(0);
    const filtros = ref({
      perPage: 15,
      acao: "",
      mapeamento: "",
      matricula: "",
      usuario_nome: "",
      usuario_id: "",
      role: "",
      data_inicial: "",
      data_final: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    //Define a data inicial ao montar o componente (15 Dias para tras)
    const getDataInicialPadrao = () => {
      let data = new Date();
      data.setDate(data.getDate() - 15);
      return format(data, "DD/MM/YYYY");
    };
    const getDataFinalPadrao = () => {
      let data = new Date();
      return format(data, "DD/MM/YYYY");
    };
    const baixarPlanilha = (url) => {
      if (!url) return;
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("configuracao/getLogsPlanilhas", {
          page: page,
          per_page: rowsPerPage,
          action: filtros.value.acao == "" ? undefined : filtros.value.acao,
          id: filtros.value.id == "" ? undefined : filtros.value.id,
          mapeamento:
            filtros.value.mapeamento == ""
              ? undefined
              : filtros.value.mapeamento,
          matricula:
            filtros.value.matricula == "" ? undefined : filtros.value.matricula,
          usuario_nome:
            filtros.value.usuario_nome == ""
              ? undefined
              : filtros.value.usuario_nome,
          usuario_id:
            filtros.value.usuario_id == ""
              ? undefined
              : filtros.value.usuario_id,
          url: filtros.value.url == "" ? undefined : filtros.value.url,
          created_at:
            filtros.value.created_at == ""
              ? undefined
              : date.formatDate(
                  filtros.value.created_at,
                  "DD/MM/YYYY HH:mm:ss"
                ),
          role: filtros.value.role == "" ? undefined : filtros.value.role,
          data_inicial:
            filtros.value.data_inicial == ""
              ? undefined
              : filtros.value.data_inicial,
          data_final:
            filtros.value.data_final == ""
              ? undefined
              : filtros.value.data_final,
        });

        rows.value = response.data.result.data;

        pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.rowsNumber = response.data.result.total;
        logsQuantidade.value = response.data.result.total;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    onMounted(() => {
      filtros.value.data_inicial = getDataInicialPadrao();
      filtros.value.data_final = getDataFinalPadrao();
    });

    const routeNotificacao = async () => {
      router.push({
        name: "configuracao-lista-logs-planilha",
      });
    };

    watchDebounced(
      [
        () => filtros.value.perPage,
        () => filtros.value.mapeamento,
        () => filtros.value.matricula,
        () => filtros.value.usuario_id,
        () => filtros.value.usuario_nome,
        () => filtros.value.role,
        () => filtros.value.data_final,
        () => filtros.value.data_inicial,
      ],
      () => {
        if (
          filtros.value.data_inicial != "" &&
          filtros.value.data_inicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.data_final != "" &&
          filtros.value.data_final.length != 10
        ) {
          return;
        }
        getDados(pagination.value.page, +filtros.value.perPage);
      },
      { debounce: 400 }
    );

    watchDebounced(
      () => filter.value,
      () => {
        getDados();
      },
      { debounce: 400 }
    );

    return {
      rows,
      columns,
      getDados,
      baixarPlanilha,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      logsQuantidade,
      routeNotificacao,
      verLog,
      log,
      filtros,
      filter: ref(""),
      listaMapeamento: [
        "produto",
        "produto_edicao_acciona",
        "delete_produto",
        "produto_acciona",
        "usuario",
      ],
      validarDataEmissao,
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button-link {
  cursor: pointer;
  color: #0000ff;
  text-decoration: underline;
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
